module.exports = __webpack_public_path__ + "img/o_5.9b51473c.png";